/* eslint-disable react/jsx-no-useless-fragment */
import { Settings2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { IPostDetailResponse } from '@/redux/post/post.d';

function JobSettingsCard({ post }: { post: IPostDetailResponse }) {
  return post.zZeroPosition ||
    post.xyDatumPosition ||
    post.softwareUsed ||
    post.materialUsed ? (
    <Card>
      <CardHeader>
        <div className="flex gap-2 items-center">
          <Settings2 className="h-5 w-5" />
          <CardTitle>Job Settings</CardTitle>
        </div>
      </CardHeader>
      <CardContent>
        <dl className="grid gap-2 text-sm">
          {post.zZeroPosition ? (
            <div className="grid grid-cols-2">
              <dt className="font-medium text-muted-foreground">
                Z Zero Position:
              </dt>
              <dd>{post.zZeroPosition}</dd>
            </div>
          ) : (
            <></>
          )}
          {post.xyDatumPosition ? (
            <div className="grid grid-cols-2">
              <dt className="font-medium text-muted-foreground">
                XY Datum Position:
              </dt>
              <dd>{post.xyDatumPosition}</dd>
            </div>
          ) : (
            <></>
          )}
          <Separator className="my-4" />
          {post.softwareUsed ? (
            <div className="grid grid-cols-2">
              <dt className="font-medium text-muted-foreground">Software:</dt>
              <dd>{post.softwareUsed}</dd>
            </div>
          ) : (
            <></>
          )}
          {post.materialUsed ? (
            <div className="grid grid-cols-2">
              <dt className="font-medium text-muted-foreground">Material:</dt>
              <dd>{post.materialUsed}</dd>
            </div>
          ) : (
            <></>
          )}
        </dl>
      </CardContent>
    </Card>
  ) : (
    <></>
  );
}

export default JobSettingsCard;
